// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.background-overlay {
  display: flex;
  flex-direction: column;
  z-index: 98;
  background-color: rgba(224, 224, 224, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.compare-dialog-container {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 80vh;
  width: 70vw;
  border-radius: 50px;
  background: white;
  box-shadow: 20px 20px 60px #d9d9d9, -20px -20px 60px #e0e0e0;
  z-index: 99;
  padding: 30px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.compare-header {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.compare-header h1 {
  font-size: 25px;
  font-weight: normal;
  text-align: center;
}

.header-title {
  padding: 10px 10px 5px 10px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}

.header-button-container {
  position: absolute;
  right: 10px;
  top: 49%;
  transform: translateY(-50%);
}

.compare-button {
  background-color: #e7e7e7; /* Button background color */
  color: white; /* Text color */
  border: 2px solid #e7e7e7; /* No border */
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  z-index: 1000;
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.compare-button p {
  color: white;
  margin: 0;
}

.compare-body {
  display: flex;
  flex-direction: column;
  min-height: 40vh;
  transition: margin-top 0.3s ease;
}

.compare-filter-container {
  position: relative;
  margin-top: 16px;
  width: 200px;
}
.compare-filter-container input {
  background-color: #e7e7e7;
  width: 200px;
  border: 1px solid #7D7979;
  font-size: 16px;
  padding: 5px 5px 5px 5px;
  color: black;
  outline: none;
  text-align: center;
}

.retailer-section-title {
  background-color: #1B3E78;
  color: white;
  width: 350px;
  padding: 10px;
  margin-bottom: 5px;
}
.retailer-section-title h3 {
  font-weight: normal;
  margin: 0;
}

.retailer-card-container, .list-card-container, .sector-card-container, .cluster-card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 28vh;
  overflow-y: scroll;
  justify-content: center;
}

.generic-button {
  margin: 10px;
}
.generic-button:disabled {
  color: grey;
  cursor: not-allowed;
}

.retailer-card, .list-card, .sector-card, .cluster-card {
  display: flex;
  width: 250px;
  height: 60px;
  flex-direction: row;
  padding: 0 10px 0 10px;
  margin: 10px 10px 0 0;
  border-radius: 10px;
  background-color: white;
}

.retailer-card {
  border: 2px solid #1B3E78;
}

.list-card {
  border: 2px solid #0CAD99;
}

.sector-card {
  border: 2px solid #3792BF;
}

.cluster-card {
  border: 2px solid #AACCFF;
}

.retailer-card .retailer-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  margin-left: 10px;
}
.retailer-card .retailer-logo-container img {
  max-width: 100%;
  max-height: 40px;
}

.retailer-card .card-content-container {
  padding: 10px;
}
.retailer-card .card-content-container .retailer-name {
  font-size: 17px;
  margin: 0;
}
.retailer-card .card-content-container .retailer-sector {
  font-weight: lighter;
  font-size: 14px;
  color: #787476;
  margin: 0;
}

.list-card .list-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  margin-left: 10px;
}
.list-card .list-logo-container img {
  max-width: 100%;
  max-height: 40px;
}

.list-card .card-content-container {
  padding: 10px;
}
.list-card .card-content-container .list-name {
  font-size: 17px;
  margin: 0;
}
.list-card .card-content-container .list-description {
  font-weight: lighter;
  font-size: 14px;
  color: #787476;
  margin: 0;
}

.sector-card .sector-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  margin-left: 10px;
}
.sector-card .sector-logo-container img {
  max-width: 100%;
  max-height: 40px;
}

.sector-card .card-content-container {
  padding: 10px;
}
.sector-card .card-content-container .sector-name {
  font-size: 17px;
  margin: 0;
}
.sector-card .card-content-container .sector-description {
  font-weight: lighter;
  font-size: 14px;
  color: #787476;
  margin: 0;
}

.cluster-card .cluster-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  margin-left: 10px;
}
.cluster-card .cluster-logo-container img {
  max-width: 100%;
  max-height: 40px;
}

.cluster-card .card-content-container {
  padding: 10px;
}
.cluster-card .card-content-container .cluster-name {
  font-size: 17px;
  margin: 0;
}
.cluster-card .card-content-container .cluster-description {
  font-weight: lighter;
  font-size: 14px;
  color: #787476;
  margin: 0;
}

.tab-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.tab-wrapper .tab {
  width: 67vw;
  height: 60px;
  margin: 0 20px;
  padding-left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  border-radius: 12px;
  transition: background-color 0.3s ease;
  appearance: none;
  border: none;
  box-shadow: none;
  padding-right: 40px;
  background-image: url("data:image/svg+xml,%3Csvg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 24px;
  font-size: 20px;
  text-align: center;
}

.tab-content {
  padding: 20px;
  border-radius: 12px;
  text-align: center;
}

.highlighted-retailer {
  color: #0CAD99;
  font-weight: bold;
}

.x-button {
  cursor: pointer;
  z-index: 9999;
}
.x-button:hover {
  color: #333;
}
.x-button--small {
  position: absolute;
  font-size: 0.75rem;
  top: 0.5rem;
  left: 14rem;
  background: none;
  color: grey;
  border: none;
  cursor: pointer;
  z-index: 10000;
}
.x-button--large {
  position: absolute;
  font-size: 1.25rem;
  top: 0.2rem;
  left: 0.2rem;
  background: none;
  color: grey;
  border: none;
  cursor: pointer;
  z-index: 10000;
}

.subtext {
  font-size: 0.75rem;
  color: #666;
  margin: 10px 0;
}
.subtext--green {
  margin: 0;
  color: #0CAD99;
  font-size: 0.75rem;
}

input[type=checkbox]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Optional: if you have a label next to it */
.checkbox-label:has(input:disabled) {
  opacity: 0.5;
}

app-loader {
  margin-top: 100px;
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 0px;
  justify-content: center;
}
.selected-chips .chip {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 14px;
  color: #333;
}
.selected-chips .chip--retailer {
  border: 2px solid #1B3E78;
}
.selected-chips .chip--ranking {
  border: 2px solid #0CAD99;
}
.selected-chips .chip--sector {
  border: 2px solid #3792BF;
}
.selected-chips .chip--cluster {
  border: 2px solid #AACCFF;
}
.selected-chips .chip .remove-chip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.selected-chips .chip .remove-chip:hover {
  color: #333;
}

.retailer-select {
  background: none;
  color: grey;
  border: none;
  margin-left: 0.5rem;
  font-size: 1.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  vertical-align: middle;
}

.ranking-select-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.ranking-option {
  display: flex;
  align-items: center;
}

.ranking-label {
  margin-right: 10px;
}

@media (max-width: 945px) {
  .compare-dialog-container {
    margin-left: 0;
  }
  .retailer-section-title {
    width: inherit;
  }
  .header-button-container {
    right: 2px;
    top: 0%;
    width: 100%;
    z-index: 999;
  }
  .compare-header {
    min-height: 15dvh;
  }
  .compare-header h1 {
    padding-top: 10px;
    margin-bottom: 5px;
  }
  .retailer-card, .list-card, .sector-card, .cluster-card {
    width: 220px;
  }
  .ranking-select-container {
    margin-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/shared/toolbox/dialogs/compare-dialog/compare-dialog.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACAF;ADEE;EACE,4BAAA;ACAJ;ADEI;EACE,YAAA;ACAN;;AFZA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADUJ;ACPM;EACE,sHAAA;ADSR;ACLI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADON;ACJI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADMN;ACHI;EACE,mBAAA;EACA,sBAAA;ADKN;;ACEE;EACE,qCAAA;ADCJ;ACEE;EACE,0BAAA;ADAJ;;ACME;EACE,0BAAA;ADHJ;ACME;EACE,uFAAA;ADJJ;;AEzDA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF0DA;;AEvDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF0DJ;;AEtDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFuDJ;;AElDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFmBR;;AEbA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFwEb;;AEXA;EAAa,YAAA;AFeb;;AEdA;EAAO,SAAA;EAAW,iDAAA;AFmBlB;;AEhBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFiBJ;AEfI;EACI,YAAA;EACA,SAAA;AFiBR;;AEdA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFiGb;AEfI;EACI,cAnFK;AFoGb;;AEbA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF4Ff;AEdE;EACE,cA/EW;AF+Ff;;AEZA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFeJ;;AAjKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0CAAA;EACA,0BAAA;EACA,kCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAoKF;;AAhKA;EACE,wBAAA;EAAA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,4DAAA;EAEA,WAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;AAiKF;;AAzJA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA4JF;AA1JE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AA4JJ;;AAxJA;EACE,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA2JF;;AAxJA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AA2JF;;AAxJA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AA2JF;;AAxJA;EACE,yBEdgB,EFcoB,4BAAA;EACpC,YAAA,EAAA,eAAA;EACA,yBAAA,EAAA,cAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,4BAAA;EACA,kBAAA;EACA,aAAA;EAGA,iCAAA,EAAA,+BAAA;AAyJF;AAvJE;EACE,YAAA;EACA,SAAA;AAyJJ;;AArJA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;AAwJF;;AArJA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AAwJF;AAtJE;EACE,yBE5Cc;EF6Cd,YAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAwJJ;;AApJA;EACE,yBE1EW;EF2EX,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAuJF;AArJE;EACE,mBAAA;EACA,SAAA;AAuJJ;;AAnJA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAsJF;;AAlJA;EACE,YAAA;AAqJF;AAnJE;EACE,WAAA;EACA,mBAAA;AAqJJ;;AAjJA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAoJF;;AAjJA;EACE,yBAAA;AAoJF;;AAjJA;EACE,yBAAA;AAoJF;;AAjJA;EACE,yBAAA;AAoJF;;AAjJA;EACE,yBAAA;AAoJF;;AAjJA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAoJF;AAlJE;EACE,eAAA;EACA,gBAAA;AAoJJ;;AA7IA;EACE,aAAA;AAgJF;AA9IE;EACE,eAAA;EACA,SAAA;AAgJJ;AA5IE;EACE,oBAAA;EACA,eAAA;EACA,cE7Ic;EF8Id,SAAA;AA8IJ;;AAxIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AA2IF;AAzIE;EACE,eAAA;EACA,gBAAA;AA2IJ;;AApIA;EACE,aAAA;AAuIF;AArIE;EACE,eAAA;EACA,SAAA;AAuIJ;AAnIE;EACE,oBAAA;EACA,eAAA;EACA,cEhLc;EFiLd,SAAA;AAqIJ;;AA/HA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAkIF;AAhIE;EACE,eAAA;EACA,gBAAA;AAkIJ;;AA3HA;EACE,aAAA;AA8HF;AA5HE;EACE,eAAA;EACA,SAAA;AA8HJ;AA1HE;EACE,oBAAA;EACA,eAAA;EACA,cEnNc;EFoNd,SAAA;AA4HJ;;AAtHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AAyHF;AAvHE;EACE,eAAA;EACA,gBAAA;AAyHJ;;AAlHA;EACE,aAAA;AAqHF;AAnHE;EACE,eAAA;EACA,SAAA;AAqHJ;AAjHE;EACE,oBAAA;EACA,eAAA;EACA,cEtPc;EFuPd,SAAA;AAmHJ;;AA7GA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAgHF;AA9GE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EAIA,gBAAA;EAEA,YAAA;EACA,gBAAA;EACA,mBAAA;EAEA,wLAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAEA,eAAA;EACA,kBAAA;AA4GJ;;AAxGA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA2GF;;AAxGA;EACE,cE5Te;EF6Tf,iBAAA;AA2GF;;AAxGA;EACE,eAAA;EACA,aAAA;AA2GF;AAzGE;EACE,WAAA;AA2GJ;AAzGE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AA2GJ;AAzGE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AA2GJ;;AAvGA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AA0GF;AAzGE;EACE,SAAA;EACA,cErWa;EFsWb,kBAAA;AA2GJ;;AAvGA;EACE,YAAA;EAEA,mBAAA;AAyGF;;AAtGA,6CAAA;AACA;EACE,YAAA;AAyGF;;AAtGA;EACE,iBAAA;AAyGF;;AAtGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAyGF;AAvGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAyGJ;AAvGI;EACE,yBAAA;AAyGN;AAtGI;EACE,yBAAA;AAwGN;AArGI;EACE,yBAAA;AAuGN;AApGI;EACE,yBAAA;AAsGN;AAnGI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAqGN;AAnGM;EACE,WAAA;AAqGR;;AA9FA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAiGF;;AA9FA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAiGF;;AA9FA;EACE,aAAA;EACA,mBAAA;AAiGF;;AA9FA;EACE,kBAAA;AAiGF;;AA9FA;EACE;IACE,cAAA;EAiGF;EA/FA;IACE,cAAA;EAiGF;EA9FA;IACE,UAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;EAgGF;EA7FA;IACE,iBAAA;EA+FF;EA7FE;IACE,iBAAA;IACA,kBAAA;EA+FJ;EA3FA;IACE,YAAA;EA6FF;EA1FA;IACE,eAAA;EA4FF;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import '../../../../../styles';\n\n.background-overlay {\n  display: flex;\n  flex-direction: column;\n  z-index: 98;\n  background-color: rgba(#e0e0e0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n\n}\n\n.compare-dialog-container {\n  height: fit-content;\n  max-height: 80vh;\n  width: 70vw;\n  border-radius: 50px;\n  background: white;\n  box-shadow: 20px 20px 60px #d9d9d9,\n  -20px -20px 60px #e0e0e0;\n  z-index: 99;\n  padding: 30px;\n\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  //margin-left:25vw;\n  //margin-right: 5vw;\n\n\n}\n\n.compare-header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  h1 {\n    font-size: 25px;\n    font-weight: normal;\n    text-align: center;\n  }\n}\n\n.header-title {\n  padding: 10px 10px 5px 10px;\n  margin-bottom: 10px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column; // vertical stacking\n  text-align: center;\n}\n\n.header-body {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n.header-button-container {\n  position: absolute;\n  right: 10px;\n  top: 49%;\n  transform: translateY(-50%); // Vertically center the button\n}\n\n.compare-button {\n  background-color: $theme-lightgray; /* Button background color */\n  color: white; /* Text color */\n  border: 2px solid $theme-lightgray; /* No border */\n  border-radius: 5px; /* Rounded corners */\n  padding: 10px 20px; /* Padding for button size */\n  margin-right: 10px;\n  z-index: 1000;\n  // font-size: 16px;       /* Font size */\n\n  transition: background-color 0.3s; /* Smooth transition on hover */\n\n  p {\n    color: white;\n    margin: 0;\n  }\n}\n\n.compare-body {\n  display: flex;\n  flex-direction: column;\n  min-height: 40vh;\n  transition: margin-top 0.3s ease;\n}\n\n.compare-filter-container {\n  position: relative;\n  margin-top: 16px;\n  width: 200px;\n\n  input {\n    background-color: $theme-lightgray;\n    width: 200px;\n    border: 1px solid $theme-4;\n    font-size: 16px;\n    padding: 5px 5px 5px 5px;\n    color: black;\n    outline: none;\n    text-align: center;\n  }\n}\n\n.retailer-section-title {\n  background-color: $theme-main;\n  color: white;\n  width: 350px;\n  padding: 10px;\n  margin-bottom: 5px;\n\n  h3 {\n    font-weight: normal;\n    margin: 0;\n  }\n}\n\n.retailer-card-container, .list-card-container, .sector-card-container, .cluster-card-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  max-height: 28vh;\n  overflow-y: scroll;\n  justify-content: center;\n\n}\n\n.generic-button {\n  margin: 10px;\n\n  &:disabled {\n    color: grey;\n    cursor: not-allowed;\n  }\n}\n\n.retailer-card, .list-card, .sector-card, .cluster-card {\n  display: flex;\n  width: 250px;\n  height: 60px;\n  flex-direction: row;\n  padding: 0 10px 0 10px;\n  margin: 10px 10px 0 0;\n  border-radius: 10px;\n  background-color: white;\n}\n\n.retailer-card {\n  border: 2px solid $theme-main;\n}\n\n.list-card {\n  border: 2px solid $theme-contrast;\n}\n\n.sector-card {\n  border: 2px solid $theme-1;\n}\n\n.cluster-card {\n  border: 2px solid $theme-2;\n}\n\n.retailer-card .retailer-logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  margin-left: 10px;\n\n  img {\n    max-width: 100%;\n    max-height: 40px;\n\n  }\n\n\n}\n\n.retailer-card .card-content-container {\n  padding: 10px;\n\n  .retailer-name {\n    font-size: 17px;\n    margin: 0;\n\n  }\n\n  .retailer-sector {\n    font-weight: lighter;\n    font-size: 14px;\n    color: $theme-gray-text;\n    margin: 0;\n\n\n  }\n}\n\n.list-card .list-logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  margin-left: 10px;\n\n  img {\n    max-width: 100%;\n    max-height: 40px;\n\n  }\n\n\n}\n\n.list-card .card-content-container {\n  padding: 10px;\n\n  .list-name {\n    font-size: 17px;\n    margin: 0;\n\n  }\n\n  .list-description{\n    font-weight: lighter;\n    font-size: 14px;\n    color: $theme-gray-text;\n    margin: 0;\n\n\n  }\n}\n\n.sector-card .sector-logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  margin-left: 10px;\n\n  img {\n    max-width: 100%;\n    max-height: 40px;\n\n  }\n\n\n}\n\n.sector-card .card-content-container {\n  padding: 10px;\n\n  .sector-name {\n    font-size: 17px;\n    margin: 0;\n\n  }\n\n  .sector-description {\n    font-weight: lighter;\n    font-size: 14px;\n    color: $theme-gray-text;\n    margin: 0;\n\n\n  }\n}\n\n.cluster-card .cluster-logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  margin-left: 10px;\n\n  img {\n    max-width: 100%;\n    max-height: 40px;\n\n  }\n\n\n}\n\n.cluster-card .card-content-container {\n  padding: 10px;\n\n  .cluster-name {\n    font-size: 17px;\n    margin: 0;\n\n  }\n\n  .cluster-description {\n    font-weight: lighter;\n    font-size: 14px;\n    color: $theme-gray-text;\n    margin: 0;\n\n\n  }\n}\n\n.tab-wrapper {\n  display: flex;\n  flex-direction: column; // stack children vertically\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n\n  .tab {\n    width: 67vw;\n    height: 60px;\n    margin: 0 20px;\n    padding-left: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    color: white;\n    border-radius: 12px;\n    transition: background-color 0.3s ease;\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\n    border: none;\n    box-shadow: none;\n    padding-right: 40px;\n\n    background-image: url(\"data:image/svg+xml,%3Csvg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 24px;\n\n    font-size: 20px;\n    text-align: center;\n  }\n}\n\n.tab-content {\n  padding: 20px;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.highlighted-retailer {\n  color: $theme-contrast; // Or any color you want\n  font-weight: bold; // Optional, if you want emphasis\n}\n\n.x-button {\n  cursor: pointer;\n  z-index: 9999;\n\n  &:hover {\n    color: #333;\n  }\n  &--small {\n    position: absolute;\n    font-size: 0.75rem;\n    top: 0.5rem;\n    left: 14rem;\n    background: none;\n    color: grey;\n    border: none;\n    cursor: pointer;\n    z-index: 10000;\n  }\n  &--large {\n    position: absolute;\n    font-size: 1.25rem;\n    top: 0.2rem;\n    left: 0.2rem;\n    background: none;\n    color: grey;\n    border: none;\n    cursor: pointer;\n    z-index: 10000;\n  }\n}\n\n.subtext {\n  font-size: 0.75rem;\n  color: #666;\n  margin: 10px 0;\n  &--green {\n    margin: 0;\n    color: $theme-contrast;\n    font-size: 0.75rem;\n  }\n}\n\ninput[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n\n  cursor: not-allowed;\n}\n\n/* Optional: if you have a label next to it */\n.checkbox-label:has(input:disabled) {\n  opacity: 0.5;\n}\n\napp-loader {\n  margin-top: 100px;\n}\n\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px; // Adjust margin if necessary\n  margin-bottom: 0px; // Ensure there's space below\n  justify-content: center;\n\n  .chip {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border-radius: 10px;\n    padding: 4px 8px;\n    font-size: 14px;\n    color: #333;\n\n    &--retailer {\n      border: 2px solid $theme-main;\n    }\n\n    &--ranking {\n      border: 2px solid $theme-contrast;\n    }\n\n    &--sector {\n      border: 2px solid $theme-1;\n    }\n\n    &--cluster {\n      border: 2px solid $theme-2;\n    }\n\n    .remove-chip {\n      margin-left: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      color: #666;\n\n      &:hover {\n        color: #333;\n      }\n    }\n  }\n}\n\n\n.retailer-select {\n  background: none;\n  color: grey;\n  border: none;\n  margin-left: 0.5rem;\n  font-size: 1.5rem; // Match the heading size\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  vertical-align: middle;\n}\n\n.ranking-select-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top:20px\n}\n\n.ranking-option {\n  display: flex;\n  align-items: center;\n}\n\n.ranking-label {\n  margin-right: 10px;\n}\n\n@media (max-width:945px) {\n  .compare-dialog-container {\n    margin-left: 0;\n  }\n  .retailer-section-title {\n    width: inherit;\n  }\n\n  .header-button-container {\n    right: 2px;\n    top: 0%;\n    width: 100%;\n    z-index: 999;\n  }\n\n  .compare-header {\n    min-height: 15dvh;\n\n    h1 {\n      padding-top: 10px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .retailer-card, .list-card, .sector-card, .cluster-card {\n    width: 220px;\n  }\n\n  .ranking-select-container {\n    margin-top: 0px;\n  }\n\n  .tab-wrapper {\n\n  //  .tab {\n  //    transition: margin-top 0.3s ease\n  //  }\n  }\n\n}\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
